import { message } from 'antd';
import { Icon } from '../../icon/icon';

export const openMessageWarning = ({ content, icon, iconColor, ...props }) => {
  message.open({
    content: <span className="text-title-medium">{content}</span>,
    icon: (
      <span
        className="w-24 h-24 flex"
        style={{ color: iconColor ?? '#F97D16' }}
      >
        {icon ?? <Icon.ICWarning />}
      </span>
    ),
  });
};
